import { Route, Routes } from "react-router-dom";
import Changelog from "view/changelog/Changelog";

const index = () => {
	return (
		<Routes>
			<Route index element={<Changelog />} />
		</Routes>
	);
};

export default index;
